/** Core script to handle nette flashMessage. **/
const netteToastNotification = function () {
    /** initializes global notification system */
    const handleSetNotifications = function () {
        /** toastr notification library init */
        toastr.options = {
            "closeButton": false,
            "debug": false,
            "newestOnTop": true,
            "progressBar": true,
            "positionClass": "toastr-top-right",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "5000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        };
    };

    /** Show notification */
    const notifyToastr = function (status, message) {
        if (status === "success") {
            toastr.success(message);
        } else if (status === "error") {
            toastr.error(message);
        } else if (status === "info") {
            toastr.info(message);
        } else if (status === "warning") {
            toastr.info(message);
        }
    };

    /**
     * Process flash messages from Nette as toaster. Data for notifications are in layout.
     */
    const processFlashMessages = function () {
        $(".nette-flash-container span").each(function () {
            notifyToastr($(this).data('type'), $(this).data('message'));
        });
    };

    return {
        /** main function to initiate the theme */
        init: function () {
            handleSetNotifications();
            processFlashMessages();
        }
    };

}();

jQuery(document).ready(function () {
    netteToastNotification.init();
});